/**
 * Utilities for converting between Tailwind opacity modifiers and hex alpha values.
 *
 * Tailwind CSS supports opacity modifiers like: text-primary/90, bg-white/50
 * These utilities help convert between:
 * - Tailwind opacity (0-100)
 * - Hex alpha channel (00-FF)
 */

/**
 * Convert Tailwind opacity value (0-100) to hex alpha (00-FF)
 */
export function tailwindOpacityToHexAlpha(opacity: number): string {
  const alpha = Math.round((opacity / 100) * 255);
  return alpha.toString(16).toUpperCase().padStart(2, '0');
}

/**
 * Convert hex alpha (00-FF) to Tailwind opacity value (0-100)
 */
export function hexAlphaToTailwindOpacity(hexAlpha: string): number {
  const alpha = parseInt(hexAlpha, 16);
  return Math.round((alpha / 255) * 100);
}

/**
 * Extract opacity value from Tailwind class
 */
export function extractOpacityFromClass(className: string): number | undefined {
  const parts = className.split('/');
  if (parts.length === 2 && parts[1]) {
    const opacity = parseInt(parts[1], 10);
    return Number.isNaN(opacity) ? undefined : opacity;
  }
  return undefined;
}

/**
 * Extract base class without opacity modifier
 */
export function extractBaseClass(className: string): string {
  return className.split('/')[0] || '';
}
